<template>
  <dropdown
    v-if="componentType === 'dropdown'"
    v-model="currentLocale"
    :items="availableLanguages"
    :hide-details="hideDetails"
    :dense="dense"
    :item-value="itemValue"
    :item-text="itemText"
    :class="componentClass"
    @change="handleLanguageChange"
  />
  <autocomplete
    v-else-if="componentType === 'autocomplete'"
    v-model="currentLocale"
    :items="availableLanguages"
    :hide-details="hideDetails"
    :dense="dense"
    :item-value="itemValue"
    :item-text="itemText"
    :class="componentClass"
    @change="handleLanguageChange"
  />
  <autocomplete
    v-else
    v-model="currentLocale"
    :items="availableLanguages"
    :hide-details="hideDetails"
    :item-value="itemValue"
    :item-text="itemText"
    :class="componentClass"
    @change="handleLanguageChange"
  />
</template>

<script>
export default {
  name: "LanguageSelector",
  props: {
    componentType: {
      type: String,
      default: "v-select", // 'autocomplete', 'dropdown', or 'v-select'
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: "code",
    },
    itemText: {
      type: String,
      default: "text",
    },
    componentClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    currentLocale: {
      get() {
        return this.$i18n.locale;
      },
      set(value) {
        this.$i18n.locale = value;
      },
    },
    availableLanguages() {
      const restaurant = this.restaurant || this.company?.restaurant;
      const allLanguages = this.getAvailableLanguages();

      let allowedCodes = [];

      if (restaurant?.id === 1) {
        const allResLangs = (this.company?.restaurants || []).flatMap(
          (res) => res.settings?.language || []
        );
        allowedCodes = [...new Set(allResLangs)];
      } else {
        allowedCodes = restaurant?.settings?.language || [];
      }

      if (allowedCodes.length === 0) {
        return allLanguages;
      }

      const uniqueAllowedCodes = new Set(allowedCodes);
      return allLanguages.filter((lang) => uniqueAllowedCodes.has(lang.code));
    },
    restaurant() {
      return this.$store.state.restaurant;
    },
    company() {
      return this.$store.state.company;
    },
  },
  methods: {
    handleLanguageChange() {
      this.setLang();
      this.$emit("language-changed", this.currentLocale);
    },
    setLang() {
      // Persist the user's own choice so a page refresh doesn't lose it -
      // this was missing entirely before (reported 16.09: pick Latinica,
      // refresh, back to ćirilica). Read on load by the `setLang` mixin
      // (src/mixins/setLang.js) and by App.vue's availableLanguages watcher.
      localStorage.setItem("restorani-lang", this.$i18n.locale);

      // Language change logic
      if (this.$i18n.locale == "rs-lat" || this.$i18n.locale == "sr-lat") {
        this.$store.state.isLatin = 0;
        this.$store.commit("SAVE_LANGUAGE", 1 - this.$store.state.isLatin);
      }
      if (this.$i18n.locale == "rs" || this.$i18n.locale == "sr") {
        this.$store.state.isLatin = 1;
        this.$store.commit("SAVE_LANGUAGE", 1 - this.$store.state.isLatin);
      }
      if (this.$i18n.locale == "hr") {
        this.$store.state.isLatin = 0;
        this.$store.commit("SAVE_LANGUAGE", 1 - this.$store.state.isLatin);
      }

      // Emit to parent components if needed
      this.$emit("setLang");
    },
  },
  watch: {
    "$i18n.locale"() {
      if (this.$i18n.locale == "rs-lat" || this.$i18n.locale == "sr-lat") {
        this.$store.state.isLatin = 0;
        this.$store.commit("SAVE_LANGUAGE", 1 - this.$store.state.isLatin);
      }
      if (this.$i18n.locale == "rs" || this.$i18n.locale == "sr") {
        this.$store.state.isLatin = 1;
        this.$store.commit("SAVE_LANGUAGE", 1 - this.$store.state.isLatin);
      }
      if (this.$i18n.locale == "hr") {
        this.$store.state.isLatin = 0;
        this.$store.commit("SAVE_LANGUAGE", 1 - this.$store.state.isLatin);
      }
    },
  },
};
</script>
